import React from "react";
import { useRouteMatch } from "react-router";
import { Route, Switch } from "react-router-dom";
import ApplyForMortgageBrokerLicenceView from "../container/MRA/ApplyForMortgageBrokerLicenceView";
import MraRJSCSearch from "../container/MRA/MraRJSCSearch";

import MraRJSCSearchResult from "../container/MRA/MraRJSCSearchResult";
import MraRJSCAdvanceSearchResult from "../container/MRA/MraRJSCAdvanceSearchResult";
import MraRJSCDetailReview from "../container/MRA/MraRJSCDetailReview";
import MraRJSCCompanyDetail from "../container/MRA/MraRJSCCompanyDetail";
import { MraRJSCEnterCompanyInfo } from "../container/MRA/MraRJSCEnterCompanyInfo";
import { MraRJSCEnterCompanyOfficals } from "../container/MRA/MraRJSCEnterCompanyOfficials";

import { HasWorkExperienceQuestionView } from "../container/MRA/HasWorkExperienceQuestionView";
import { IsNineteenQuestionView } from "../container/MRA/IsNineteenQuestionView";
import { IsResidentOfCanadaQuestionView } from "../container/MRA/IsResidentOfCanadaQuestionView";
import { PrincipalBroker } from "../container/MRA/PrincipalBroker";
import { PrivacyNoticeView } from "../container/MRA/PrivacyNotice";
import { RegProgramCompletedQuestionView } from "../container/MRA/RegProgramCompletedQuestionView";
import { RoleWithRJSCQuestionView } from "../container/MRA/RoleWithRJSCQuestionView";
import Navigation from "../container/Navigation";
import { APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, ROUTE_PATH } from "./constants";
import { PreloadedRoute } from "../app/PreloadedRoute";
import { PreviouslyLicencedMortgageBroker } from "../container/MRA/PreviouslyLicencedMortgageBroker";
import { LicenceNumber } from "../container/MRA/LicenceNumber";
import { HasMortgageBrokerLicenceInProvinces } from "../container/MRA/HasMortgageBrokerLicenceInProvinces";
import { MortgageBrokerInfo } from "../container/MRA/MortgageBrokerInfo";
import { HasCompletedMortgageBrokerEducation } from "../container/MRA/HasCompletedMortgageBrokerEducation";
import { HasCertificateOfCompletionNovaScotia } from "../container/MRA/HasCertificateOfCompletionNovaScotia";
import { CompleteMortgageBrokerEducationOneYear } from "../container/MRA/CompleteMortgageBrokerEducationOneYear";
import { UploadCertificateMortgageEducation } from "../container/MRA/UploadCertificateMortgageEducation";
import { PrincipalBrokerUploadCertificateMortgageEducation } from "../container/MRA/PrincipalBrokerUploadCertificateMortgageEducation";
import { BeforeYouStart } from "../container/MRA/MRA-Broker-Associate/BeforeYouStart";
import { NotResidentCanada } from "../container/MRA/NotResidentCanada";
import { ProvideBrokerContactInformation } from "../container/MRA/ProvideBrokerContactInformation";
import { ConfirmCompletionRegulatoryInfo } from "../container/MRA/ConfirmCompletionRegulatoryInfo";
import { ConfirmBusinessInformation } from "../container/MRA/ConfirmBusinessInformation";
import { BrokerApplicationReview } from "../container/MRA/BrokerApplicationReview";
import BrokerNextSteps from "../container/MRA/BrokerNextSteps";
import { CompanyContactInformation } from "../container/MRA/CompanyContactInformation";
import { CompanyFinancialLocation } from "../container/MRA/CompanyFinancialLocation";
import { AppointedAgentServiceAddress } from "../container/MRA/AppointedAgentServiceAddress";
import { CompanyFiscalEndDate } from "../container/MRA/CompanyFiscalEndDate.jsx";
import { UploadCriminalRecordCheck } from "../container/MRA/UploadCriminalRecordCheck";
import { UploadCriminalRecordCheckAgency } from "../container/MRA/UploadCriminalRecordCheckAgency";
import { UploadProofOfInsurance } from "../container/MRA/UploadProofOfInsurance";
import { BrokerConfirmation } from "../container/MRA/BrokerConfirmation";
import { BrokerApplicationCompanyReview } from "../container/MRA/BrokerApplicationCompanyReview";
import { MraRegulatoryInformationNotDone } from "../container/MRA/MraRegulatoryInformationNotDone";
import { MraChoosePrincipalBroker } from "../container/MRA/MraChoosePrincipalBroker";
import { MraNoWorkExperience } from "../container/MRA/MraNoWorkExperience.jsx";
import { MraAgeNotEnough } from "../container/MRA/MraAgeNotEnough.jsx";
import { MraSelectPrincipalBroker } from "../container/MRA/MraSelectPrincipalBroker";
import { AddBrokersToBrokerage } from "../container/MRA/AddBrokersToBrokerage";
import MraPaymentPreview from "../container/MRA/MraPaymentPreview";
import { UploadWorkHistory } from "../container/MRA/UploadWorkHistory";
import { MraPaymentConfirmation } from "../container/MRA/MraPaymentConfirmation";
import { MraPricipleBrokerIneligible } from "../container/MRA/MraPrincipalBrokerIneligible";
import { AssociateBrokerAddApplicant } from "../container/MRA/MRA-Broker-Associate/AssociateBrokerAddApplicant";
// import { AssociatedBrokerRecommededLicence } from "../container/MRA/MRA-Broker-Associate/AssociatedBrokerRecommededLicence";
import { AssociateBrokerConfirmation } from "../container/MRA/MRA-Broker-Associate/AssociateBrokerConfirmation";
import { AssociateBrokerContinueApplication } from "../container/MRA/MRA-Broker-Associate/AssociateBrokerContinueApplication";
import { AssociateBrokerHasAssociateEducation } from "../container/MRA/MRA-Broker-Associate/AssocateBrokerHasAssociateEducation";
import { AssociateBrokerNotHasCertificateCompletion } from "../container/MRA/MRA-Broker-Associate/AssociateBrokerNotHasCertificateCompletion";
import { AssociateBrokerUploadCertificateCompletion } from "../container/MRA/MRA-Broker-Associate/AssociateBrokerUploadCertificateCompletion";
import { AssociateBrokerNotCompletedCourse } from "../container/MRA/MRA-Broker-Associate/AssocateBrokerNotCompletedCourse";
import { ConfirmPrincipalBroker } from "../container/MRA/Renewals/ConfirmPB";
import { ContentAwareness } from "../container/MRA/Renewals/ContentAwareness";
import { ConfirmAIRSubmission } from "../container/MRA/Renewals/ConfirmAIRSubmission";
import { ConfirmCompanyType } from "../container/MRA/Renewals/ConfirmCompanyType";
import { ConfirmCompanyFiscalEndDate } from "../container/MRA/Renewals/ConfirmCompanyFiscalEndDate";
import { ConfirmCompanyFinancialLocation } from "../container/MRA/Renewals/ConfirmCompanyFinancialLocation";
import { ConfirmAppointedAgentServiceAddress } from "../container/MRA/Renewals/ConfirmAppointedAgentServiceAddress";
import { ConfirmInsuranceProof } from "../container/MRA/Renewals/ConfirmInsuranceProof";
import { ConfirmCriminalRecordCheck } from "../container/MRA/Renewals/ConfirmCriminalRecordCheck";
import { MraRenewalApplicationReview } from "../container/MRA/Renewals/MraRenewalApplicationReview";
import ConfirmMraRenewalBeforePayment from "../container/MRA/Renewals/ConfirmMraRenewalBeforePayment";
import MraRenewalPaymentPreview from "../container/MRA/Renewals/MraRenewalPaymentPreview";
import { MraRenewalPaymentConfirmation } from "../container/MRA/Renewals/MraRenewalPaymentConfirmation";
import { MraRenewalBrokerContactInformation } from "../container/MRA/Renewals/MraRenewalBrokerContactInformation";
import { ConfirmPrincipalBrokerQualification } from "../container/MRA/Renewals/ConfirmPrincipalBrokerQualification";
import { MraRenewalBrokerEducationCertificate } from "../container/MRA/Renewals/MraRenewalBrokerEducationCertificate";
import { MraRenewalPrincipalBrokerActRegulation } from "../container/MRA/Renewals/MraRenewalPrincipalBrokerActRegulation";
import { MraRenewalBrokerCriminalRecordCheck } from "../container/MRA/Renewals/MraRenewalBrokerCriminalRecordCheck";
import { MraRenewalBrokerApplicationReview } from "../container/MRA/Renewals/MraRenewalBrokerApplicationReview";
import { ConfirmMortgageBrokerQualification } from "../container/MRA/Renewals/ConfirmMortgageBrokerQualification";
import { MraRenewalBrokerContinuingEducationConfirmation } from "../container/MRA/Renewals/MraRenewalBrokerContinuingEducationConfirmation";
import { MraRenewalBrokerContinuingEducationCertificate } from "../container/MRA/Renewals/MraRenewalBrokerContinuingEducationCertificate";
import { ApplicantCurrentlyBrokerInNS } from "../container/MRA/ApplicantCurrentlyBrokerInNS.js";
import { CurrentApplicantLicenceNumber } from "../container/MRA/CurrentApplicantLicenceNumber.js";
import { MainAgentChangeRequestReason } from "../container/MRA/MainAgentChangeRequest/MainAgentChangeRequestReason";
import { MainAgentChangeRequestNewEmail } from "../container/MRA/MainAgentChangeRequest/MainAgentChangeRequestNewEmail";
import { MainAgentChangeRequestReview } from "../container/MRA/MainAgentChangeRequest/MainAgentChangeRequestReview";
import { MainAgentChangeRequestSubmitConfirmation } from "../container/MRA/MainAgentChangeRequest/MainAgentChangeRequestSubmitConfirmation";
import FileUploadView from "../container/MRA/FileUpload/FileUploadView.jsx";
import { HasAssociateMortgageBrokerLicenceInProvinces } from "../container/MRA/HasAssociateMortgageBrokerLicenceInProvinces.jsx";

export const MortgageApp = (props) => {
  let { path } = useRouteMatch();

  return (
    <>
      <Navigation {...props} applicationType={APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE} />
      <Switch>
        <Route
          path={`${path}${ROUTE_PATH.MRA_PRIVACY_NOTICE}`}
          component={PrivacyNoticeView}
        />
        <Route
          path={`${path}${ROUTE_PATH.MRA_COMPLETED_REG_PROGRAM_QUESTION}`}
          component={RegProgramCompletedQuestionView}
        />
        <Route
          path={`${path}${ROUTE_PATH.MRA_COMPLETED_REG_PROGRAM_QUESTION_NO}`}
          component={MraRegulatoryInformationNotDone}
        />
        <Route
          path={`${path}${ROUTE_PATH.MRA_PRINCIPAL_BROKER}`}
          component={PrincipalBroker}
        />
        <Route
          path={`${path}${ROUTE_PATH.MRA_PRINCIPAL_BROKER_NO}`}
          component={MraChoosePrincipalBroker}
        />
        <Route
          path={`${path}${ROUTE_PATH.MRA_HAS_ROLE_WITH_RJSC}`}
          component={RoleWithRJSCQuestionView}
        />
        <Route
          path={`${path}${ROUTE_PATH.MRA_HAS_ROLE_WITH_RJSC_NO}`}
          component={MraChoosePrincipalBroker}
        />
        <Route
          path={`${path}${ROUTE_PATH.MRA_HAS_WORK_EXPERIENCE}`}
          component={HasWorkExperienceQuestionView}
        />
        <Route
          path={`${path}${ROUTE_PATH.MRA_HAS_WORK_EXPERIENCE_NO}`}
          component={MraNoWorkExperience}
        />
        <Route
          path={`${path}${ROUTE_PATH.MRA_IS_CANADA_RESIDENT}`}
          component={IsResidentOfCanadaQuestionView}
        />
        <Route
          path={`${path}${ROUTE_PATH.MRA_IS_CANADA_RESIDENT_NO}`}
          component={NotResidentCanada}
        />
        <Route
          path={`${path}${ROUTE_PATH.MRA_IS_NINETEEN}`}
          component={IsNineteenQuestionView}
        />
        <Route
          path={`${path}${ROUTE_PATH.MRA_IS_NINETEEN_NO}`}
          component={MraAgeNotEnough}
        />
        <Route
          path={`${path}${ROUTE_PATH.MRA_APPLY_FOR_MORTGAGE_LICENCE}`}
          component={ApplyForMortgageBrokerLicenceView}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RJSC_SEARCH}`}
          component={MraRJSCSearch}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RJSC_SEARCH_SELECT}`}
          component={MraRJSCSearchResult}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RJSC_OPERATING_NAME_SEARCH_SELECT}`}
          component={MraRJSCAdvanceSearchResult}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RJSC_DETAIL_REVIEW}`}
          component={MraRJSCDetailReview}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RJSC_COMPANY_DETAIL}`}
          component={MraRJSCCompanyDetail}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RJSC_COMPANY_INFO}`}
          component={MraRJSCEnterCompanyInfo}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RJSC_COMPANY_OFFICIALS}`}
          component={MraRJSCEnterCompanyOfficals}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_SELECT_PRINCIPAL_BROKER_FROM_LIST}`}
          component={MraSelectPrincipalBroker}
        />
        <Route
          path={`${path}${ROUTE_PATH.MRA_PREVIOUSLY_LICENCED_MORTGAGE_BROKER}`}
          component={PreviouslyLicencedMortgageBroker}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_LICENCE_NUMBER}`}
          component={LicenceNumber}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_BROKER_LICENCE_IN_PROVINCES}`}
          component={HasMortgageBrokerLicenceInProvinces}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_BROKERAGE_INFO}`}
          component={MortgageBrokerInfo}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_HAS_COMPLETETED_EDUCATION}`}
          component={HasCompletedMortgageBrokerEducation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_HAS_CERTIFICATE_NOVASCOTIA}`}
          component={HasCertificateOfCompletionNovaScotia}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_COMPLETE_BROKER_EDUCATION}`}
          component={CompleteMortgageBrokerEducationOneYear}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_UPLOAD_CERTIFICATE_EDUCATION}`}
          component={UploadCertificateMortgageEducation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_PRINCIPAL_BROKER_UPLOAD_CERTIFICATE_EDUCATION}`}
          component={PrincipalBrokerUploadCertificateMortgageEducation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_ASSOCIATE_BEFORE_YOU_START}`}
          component={BeforeYouStart}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_CURRENTLY_BROKER_IN_NS}`}
          component={ApplicantCurrentlyBrokerInNS}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_CURRENT_APPLICANT_LICENCE_NUMBER}`}
          component={CurrentApplicantLicenceNumber}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_ASSOCIATE_APPLICANT_INFO}`}
          component={AssociateBrokerAddApplicant}
        />
        {/* <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_ASSOCIATE_RECOMMENDED_LICENCE}`}
          component={AssociatedBrokerRecommededLicence}
        /> */}
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_ASSOCIATE_CONFIRMATION}`}
          component={AssociateBrokerConfirmation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_ASSOCIATE_CONTINUE_APPLICATION}`}
          component={AssociateBrokerContinueApplication}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_ASSOCIATE_HAS_EDUCATION}`}
          component={AssociateBrokerHasAssociateEducation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_ASSOCIATE_NOT_HAS_CERTIFICATE}`}
          component={AssociateBrokerNotHasCertificateCompletion}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_ASSOCIATE_UPLOAD_CERTIFICATE_COMPLETION}`}
          component={AssociateBrokerUploadCertificateCompletion}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_ASSOCIATE_HAS_LICENCE_IN_PROVICES}`}
          component={HasAssociateMortgageBrokerLicenceInProvinces}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_ASSOCIATE_BROKER_LICENCE_INFO}`}
          component={MortgageBrokerInfo}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_ASSOCIATE_NOT_HAS_COURSE}`}
          component={AssociateBrokerNotCompletedCourse}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_BROKER_CONTACT_INFORMATION}`}
          component={ProvideBrokerContactInformation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_CONFIRM_COMPLETION_REGULATORY_INFO}`}
          component={ConfirmCompletionRegulatoryInfo}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_CONFIRM_BUSINESS_INFO}`}
          component={ConfirmBusinessInformation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_BROKER_APPLICATION_REVIEW}`}
          component={BrokerApplicationReview}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_BROKER_NEXT_STEPS}`}
          component={BrokerNextSteps}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_COMPANY_CONTACT_INFO}`}
          component={CompanyContactInformation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_COMPANY_FINANCIAL_LOCATION}`}
          component={CompanyFinancialLocation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_APPOINTED_AGENT_SERVICE_ADDRESS}`}
          component={AppointedAgentServiceAddress}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_COMPANY_FISCAL_END_DATE}`}
          component={CompanyFiscalEndDate}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_UPLOAD_CRIMINAL_RECORD_CHECK}`}
          component={UploadCriminalRecordCheck}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_UPLOAD_CRIMINAL_RECORD_CHECK_AGENCY}`}
          component={UploadCriminalRecordCheckAgency}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_UPLOAD_PROOF_OF_INSURANCE}`}
          component={UploadProofOfInsurance}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_BROKER_CONFIRMATION}`}
          component={BrokerConfirmation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_BROKER_APPLICATION_COMPANY_REVEIW}`}
          component={BrokerApplicationCompanyReview}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_ADD_BROKERS_TO_BROKERAGE}`}
          component={AddBrokersToBrokerage}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_PAYMENT_PREVIEW}`}
          component={MraPaymentPreview}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_UPLOAD_WORK_HISTORY}`}
          component={UploadWorkHistory}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_PAYMENT_CONFIRMATION}`}
          component={MraPaymentConfirmation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_PRINCIPAL_BROKER_INELIGIBLE}`}
          component={MraPricipleBrokerIneligible}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_CONFIRM_PB}`}
          component={ConfirmPrincipalBroker}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_CONTENT_AWARENESS}`}
          component={ContentAwareness}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_CONFIRM_AIR_SUBMISSION}`}
          component={ConfirmAIRSubmission}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_CONFIRM_COMPANY_TYPE_SUBMISSION}`}
          component={ConfirmCompanyType}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_CONFIRM_COMPANY_FISCAL_DATE}`}
          component={ConfirmCompanyFiscalEndDate}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_CONFIRM_COMPANY_FINANCIAL_LOCATION}`}
          component={ConfirmCompanyFinancialLocation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_CONFIRM_APPOINTED_AGENT}`}
          component={ConfirmAppointedAgentServiceAddress}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_CONFIRM_INSURANCE_PROOF}`}
          component={ConfirmInsuranceProof}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_CONFIRM_CRIMINAL_RECORD_CHECK}`}
          component={ConfirmCriminalRecordCheck}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_APPLICATION_REVIEW}`}
          component={MraRenewalApplicationReview}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_CONFIRM_BEFORE_PAYMENT}`}
          component={ConfirmMraRenewalBeforePayment}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_PAYMENT_REVIEW}`}
          component={MraRenewalPaymentPreview}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_PAYMENT_CONFIRMATION}`}
          component={MraRenewalPaymentConfirmation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_BROKER_CONTACT_INFORMATION}`}
          component={MraRenewalBrokerContactInformation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_CONFIRM_PRINCIPAL_BROKER_QUALIFICATION}`}
          component={ConfirmPrincipalBrokerQualification}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_CONFIRM_MORTGAGE_BROKER_QUALIFICATION}`}
          component={ConfirmMortgageBrokerQualification}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_BROKER_CONTINUING_EDUCATION_CONFIRMATION}`}
          component={MraRenewalBrokerContinuingEducationConfirmation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_BROKER_CONTINUING_EDUCATION_CERTIFICATE}`}
          component={MraRenewalBrokerContinuingEducationCertificate}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_BROKER_EDUCATION_CERTIFICATE}`}
          component={MraRenewalBrokerEducationCertificate}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_PRINCIPAL_BROKER_ACT_REGULATION_CONFIRMATION}`}
          component={MraRenewalPrincipalBrokerActRegulation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_BROKER_CRIMINAL_RECORD_CHECK}`}
          component={MraRenewalBrokerCriminalRecordCheck}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_RENEWAL_BROKER_APPLICATION_REVIEW}`}
          component={MraRenewalBrokerApplicationReview}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_MAIN_AGENT_CHANGE_REQUEST_REASON}`}
          component={MainAgentChangeRequestReason}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_MAIN_AGENT_CHANGE_REQUEST_NEW_EMAIL}`}
          component={MainAgentChangeRequestNewEmail}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_MAIN_AGENT_CHANGE_REQUEST_REVIEW}`}
          component={MainAgentChangeRequestReview}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_MAIN_AGENT_CHANGE_REQUEST_SUBMIT_CONFIRM}`}
          component={MainAgentChangeRequestSubmitConfirmation}
        />
        <PreloadedRoute
          path={`${path}${ROUTE_PATH.MRA_FILE_UPLOAD_VIEW}`}
          component={FileUploadView}
        />
        <Route component={PrivacyNoticeView} />
      </Switch>
    </>
  );
};
